const ArticlesPreviewComponent = {
    data() {
        return {
            articles: [],
            loading: false
        }
    },
    methods: {
        async getArticles() {
            this.loading = true;
            try {

                const response = await fetch(window.appConfig.routes.getArticles, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        limit: 4
                    })
                });

                const data = await response.json();

                if (response.ok)
                    this.articles = data.data ?? [];

                this.loading = false;

            } catch (error) {

                this.messageError = "Ошибка сети";
                this.loading = false;

            }

        },

        formatViews(views) {
            const lastDigit = views % 10;
            const lastTwoDigits = views % 100;

            if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
                return `${views} просмотров`;
            }

            if (lastDigit === 1) {
                return `${views} просмотр`;
            }

            if (lastDigit >= 2 && lastDigit <= 4) {
                return `${views} просмотра`;
            }

            return `${views} просмотров`;
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            const months = [
                'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
                'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
            ];

            const day = date.getDate().toString().padStart(2, '0');
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        }
    },
    mounted() {
        this.getArticles();
    },
    computed: {
        showLoading() {
            return this.loading;
        },
        showContent() {
            return !this.loading && this.articles && this.articles.length > 0;
        }
    }
};

window.ArticlesPreviewComponent = ArticlesPreviewComponent;